import * as React from 'react';

function VisionIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 89.99 90.02"
      {...props}
    >
      <g data-name="Layer 2">
        <path
          fill="#fff"
          d="M78.75 0a1.93 1.93 0 00-1.09.5l-9 8A1.94 1.94 0 0068 10v9.15l-6.31 6.31a36.74 36.74 0 102.84 2.82L70.81 22H80a2 2 0 001.5-.69l8-9a2 2 0 00-.2-2.82A2 2 0 0088 9h-7V2a2 2 0 00-2-2 1.23 1.23 0 00-.25 0zM77 6.45V11a2 2 0 002 2h4.53l-4.44 5H72v-7.11zM37 20a32.87 32.87 0 0121.88 8.3l-7.1 7.09a23.36 23.36 0 102.81 2.84l7.1-7.09A33 33 0 1137 20zm0 14a18.94 18.94 0 0111.94 4.21l-6.44 6.46a10.27 10.27 0 102.81 2.85l6.44-6.44A19 19 0 1137 34zm0 13a5.94 5.94 0 012.56.59l-4 4a2 2 0 102.76 2.9l.06-.06 4-4A6.09 6.09 0 0143 53a6 6 0 11-6-6z"
          data-name="Layer 1"
        />
      </g>
    </svg>
  );
}

export default VisionIcon;
